// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox--e2cd4f","checkbox__control":"checkbox__control--7da1f2","checkbox__label":"checkbox__label--0a972f"};